import React, { useEffect, useState } from "react";
import { adminStore } from "../stores/AdminStore";
import { useNavigate } from "react-router-dom";
import { ProdutoCategoria } from "../types/store";

type ProdutoResumo = {
    id: number;
    nome: string;
    categoria: ProdutoCategoria;
    ativo: boolean;
    quantidadeEstoque: number
};

export const AdminProdutos: React.FC = () => {
    const [produtos, setProdutos] = useState<ProdutoResumo[]>([]);
    const [deleteId, setDeleteId] = useState<number | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        adminStore.getProductList().then(setProdutos);
    }, []);

    const handleEdit = (id: number) => {
        navigate(`/gerenciar/editarProduto/${id}`);
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    padding: 32,
                    borderRadius: 10,
                    width: "100%",
                    maxWidth: 800,
                }}
            >
                <h2 style={{ textAlign: "center", marginBottom: 24 }}>
                    Administração de Produtos
                </h2>
                <table
                    style={{ width: "100%", borderCollapse: "collapse", marginTop: 24 }}
                >
                    <thead>
                        <tr>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>ID</th>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                                Nome
                            </th>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                                Categoria
                            </th>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                                Ativo
                            </th>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                                Estoque
                            </th>
                            <th style={{ borderBottom: "1px solid #ccc", padding: 8 }}>
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {produtos.map((produto) => (
                            <tr key={produto.id}>
                                <td style={{ padding: 8 }}>{produto.id}</td>
                                <td style={{ padding: 8 }}>{produto.nome}</td>
                                <td style={{ padding: 8 }}>
                                    {produto.categoria === 1 ? "CATALOGO" : "LOJA"}
                                </td>
                                <td style={{ padding: 8 }}>
                                    <input
                                        type="checkbox"
                                        checked={produto.ativo}
                                        readOnly
                                        style={{
                                            width: 18,
                                            height: 18,
                                            accentColor: "#198754",
                                            cursor: "default",
                                        }}
                                        tabIndex={-1}
                                    />
                                </td>
                                <td style={{ padding: 8 }}>
                                    {typeof produto.quantidadeEstoque !== "undefined"
                                        ? produto.quantidadeEstoque
                                        : "-"}
                                </td>
                                <td style={{ padding: 8 }}>
                                    <button
                                        style={{
                                            background: "#198754",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: 4,
                                            padding: "6px 14px",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => handleEdit(produto.id)}
                                    >
                                        Editar
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {/* Painel de confirmação de exclusão */}
                {deleteId !== null && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            background: "rgba(0,0,0,0.4)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 1000,
                        }}
                    >
                        <div
                            style={{
                                background: "#fff",
                                padding: 32,
                                borderRadius: 8,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                minWidth: 320,
                                textAlign: "center",
                            }}
                        >
                            <p>
                                Tem certeza que deseja excluir o produto{" "}
                                <b>{produtos.find((p) => p.id === deleteId)?.nome}</b>?
                            </p>
                            <div style={{ marginTop: 24 }}>
                                <button
                                    style={{
                                        background: "#dc3545",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "8px 18px",
                                        marginRight: 12,
                                        cursor: "pointer",
                                    }}
                                    onClick={() => setDeleteId(null)}
                                >
                                    Cancelar
                                </button>
                                <button
                                    style={{
                                        background: "#198754",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: 4,
                                        padding: "8px 18px",
                                        cursor: "pointer",
                                    }}
                                    // Aqui você pode implementar a lógica de exclusão futuramente
                                    onClick={() => setDeleteId(null)}
                                >
                                    Confirmar
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
